"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query userProfilesAdmin(
    $query: UserProfileQueryInput
    $pagination: PaginationInput
  ) {
    userProfilesAdmin(query: $query, pagination: $pagination) {
      _id
      userId
      firstName
      lastName
      email
      imageUrl
      user {
        _id
        email
        firstName
        lastName
        phoneNumber
        __typename
      }
      stripeCustomerId
      analytics {
        label
        type
        interval
        intervalOptions
        coordinates {
          x
          y
          __typename
        }
        segments {
          label
          type
          coordinates {
            x
            y
            __typename
          }
          __typename
        }
        __typename
      }
      metrics {
        lifeTimeValue
        eventIds
        } 
      __typename
    }
  }
`;
exports.default = query;
//# sourceMappingURL=userProfilesAdmin.query.js.map